import {createTypes, async} from 'redux-action-creator'

export default createTypes(
  [
    'SET_TAB',
    'SET_SELECTED',
    'SET_DOCUMENT_TYPE',
    'SET_DOCUMENT_NUMBER',
    ...async('FETCH_DOCUMENT_TYPES'),
    ...async('FETCH'),
    'SET_NUMBER',
    'SET_EXPIRY',
    'SET_CVC',
    'SET_CARDHOLDER_NAME',
    ...async('SAVE'),
    ...async('MODIFY_TRANSACTION'),
  ],
  'REMOVE/PAYMENT_METHOD/',
)



// WEBPACK FOOTER //
// ./src/sections/remove/types/paymentMethod.js